/*
 * @Author: your name
 * @Date: 2022-04-29 00:28:57
 * @LastEditTime: 2022-05-17 09:35:39
 * @LastEditors: wangxi ioswangxi@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /childrenwelfare_big_screen/src/assets/mapData/西工区 copy.js
 */
const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410305003',
            ext_path: '河南省 洛阳市 涧西区 长春路街道',
            cid: '1',
            pid: '410305',
            name: '长春路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.410021, 34.667145]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305012',
            ext_path: '河南省 洛阳市 涧西区 工农街道',
            cid: '2',
            pid: '410305',
            name: '工农街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.374777, 34.666722]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305008',
            ext_path: '河南省 洛阳市 涧西区 武汉路街道',
            cid: '3',
            pid: '410305',
            name: '武汉路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.348855, 34.672877]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305014',
            ext_path: '河南省 洛阳市 涧西区 辛店镇',
            cid: '4',
            pid: '410305',
            name: '辛店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.321567, 34.591434]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305015',
            ext_path: '河南省 洛阳市 涧西区 徐家营街道',
            cid: '5',
            pid: '410305',
            name: '徐家营街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.364851, 34.606218]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305013',
            ext_path: '河南省 洛阳市 涧西区 瀛洲街道',
            cid: '6',
            pid: '410305',
            name: '瀛洲街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.351006, 34.636086]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305006',
            ext_path: '河南省 洛阳市 涧西区 重庆路街道',
            cid: '7',
            pid: '410305',
            name: '重庆路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.365444, 34.678092]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410305011',
            ext_path: '河南省 洛阳市 涧西区 周山路街道',
            cid: '8',
            pid: '410305',
            name: '周山路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.404196, 34.637577]
        }
    }
];

export { d };
